<template>
  <div style="display: flex; align-items: center">
    <el-date-picker
      :value="value"
      style="flex: 1;margin-right: 5px"
      v-bind="$attrs"
      v-on="$listeners"
    />&nbsp;
    <span>{{ sailingDay|filterWeek }}</span>
  </div>
</template>

<script>
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import lang from '@/lang'

export default {
  name: 'DatePickerShowWeek',
  filters: {
    filterWeek(val) {
      switch (val) {
        case 'TUE':
          return lang.t('SeaExport.TUE')
        case 'WED':
          return lang.t('SeaExport.WED')
        case 'THU':
          return lang.t('SeaExport.THU')
        case 'FRI':
          return lang.t('SeaExport.FRI')
        case 'SAT':
          return lang.t('SeaExport.SAT')
        case 'SUN':
          return lang.t('Pricing.Sun')
        case 'MON':
        default:
          return lang.t('SeaExport.MON')
      }
    }
  },
  props: {
    value: { type: [String, Date], default: '' }
  },
  computed: {
    sailingDay() {
      return JobUtils.dateChange(this.value)
    }
  }
}
</script>
